// extracted by mini-css-extract-plugin
export var content = "background-text-section-module--content--Yx2DY";
export var contentWrapper = "background-text-section-module--content-wrapper--mm5Sj";
export var image = "background-text-section-module--image--ihJLa";
export var main = "background-text-section-module--main--jT4he";
export var topPadding = "background-text-section-module--top-padding--YYTp4";